"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("./libs/dateFormat");

// date-format-lite adds format(mask, [zone]) method to native Date.prototype.
var dateConvert = function dateConvert(date, format) {
  var dObj = new Date(date);
  return dObj.format(format);
};

var _default = dateConvert;
exports.default = _default;